// One way to write prices everywhere on the site: "505 500 FCFA" (spaces between
// thousands, as usual in Niger). No price / 0 = "Gratuit".
export const formatPrice = (price: number | string | null | undefined): string => {
    const amount = Number(price);
    if (price === null || price === undefined || price === '' || !Number.isFinite(amount) || amount <= 0) {
        return 'Gratuit';
    }
    return `${amount.toLocaleString('fr-FR')} FCFA`;
};
